import type { TAmazonCoverSize, TCoverSize, TKindleCoverSize } from '@/types/cover'

export const coverDimensions: TCoverSize[] = [
  { name: '6x9', width: 152, height: 229 },
  { name: 'A4', width: 210, height: 297 },
  { name: 'Letter', width: 216, height: 279 },
  { name: 'A5', width: 148, height: 210 },
  { name: 'Legal', width: 216, height: 356 },
  { name: 'A3', width: 297, height: 420 },
  { name: 'Square', width: 286, height: 286 },
] as const

// 1123 to 702 but in mm. Amazon requires proportion 1.6:1
export const kindleCoverDimensions: TKindleCoverSize = {
  name: 'Kindle',
  width: 186.25,
  height: 298,
  widthMM: 1123,
  heightMM: 702,
  labels: { mm: '186.25 × 298 mm', in: '7.33" × 11.73"' },
}

export const amazonCoverDimensions: TAmazonCoverSize[] = [
  {
    name: '127_203',
    labels: { mm: '127 × 203 mm', in: '5.00" × 8.00"' },
    width: 127,
    height: 203.2,
    paperback: true,
    hardcover: false,
    popular: true,
  },
  {
    name: '133_203',
    labels: { mm: '133 × 203 mm', in: '5.25" × 8.00"' },
    width: 133.35,
    height: 203.2,
    paperback: true,
    hardcover: false,
    popular: true,
  },
  {
    name: '139_215',
    labels: { mm: '140 × 216 mm', in: '5.50" × 8.50"' },
    width: 139.7,
    height: 215.9,
    paperback: true,
    hardcover: true,
    popular: true,
  },
  {
    name: '152_228',
    labels: { mm: '152 × 229 mm', in: '6.00" × 9.00"' },
    width: 152.4,
    height: 228.6,
    paperback: true,
    hardcover: true,
    popular: true,
  },
  {
    name: '128_198',
    labels: { mm: '129 × 198 mm', in: '5.06" × 7.81"' },
    width: 128.52,
    height: 198.37,
    paperback: true,
    hardcover: false,
    popular: false,
  },
  {
    name: '155_233',
    labels: { mm: '156 × 234 mm', in: '6.14" × 9.21"' },
    width: 155.96,
    height: 233.93,
    paperback: true,
    hardcover: true,
    popular: false,
  },
  {
    name: '169_244',
    labels: { mm: '170 × 244 mm', in: '6.69" × 9.61"' },
    width: 169.93,
    height: 244.09,
    paperback: true,
    hardcover: false,
    popular: false,
  },
  {
    name: '177_254',
    labels: { mm: '178 × 254 mm', in: '7.00" × 10.00"' },
    width: 177.8,
    height: 254,
    paperback: true,
    hardcover: true,
    popular: false,
  },
  {
    name: '188_246',
    labels: { mm: '189 × 246 mm', in: '7.44" × 9.69"' },
    width: 188.98,
    height: 246.13,
    paperback: true,
    hardcover: false,
    popular: false,
  },
  {
    name: '190_234',
    labels: { mm: '191 × 235 mm', in: '7.50" × 9.25"' },
    width: 190.5,
    height: 234.95,
    paperback: true,
    hardcover: false,
    popular: false,
  },
  {
    name: '203_254',
    labels: { mm: '203 × 254 mm', in: '8.00" × 10.00"' },
    width: 203.2,
    height: 254,
    paperback: true,
    hardcover: false,
    popular: false,
  },
  {
    name: '215_279',
    labels: { mm: '216 × 279 mm', in: '8.50" × 11.00"' },
    width: 215.9,
    height: 279.4,
    paperback: true,
    hardcover: false,
    popular: false,
  },
  {
    name: '210_296',
    labels: { mm: '210 × 297 mm (A4)', in: '8.27" × 11.69"' },
    width: 210.06,
    height: 296.93,
    paperback: true,
    hardcover: false,
    popular: false,
  },
  {
    name: '209_152',
    labels: { mm: '210 × 152 mm', in: '8.25" × 6.00"' },
    width: 209.55,
    height: 152.4,
    paperback: true,
    hardcover: false,
    popular: false,
  },
  {
    name: '209_209',
    labels: { mm: '210 × 210 mm', in: '8.25" × 8.25"' },
    width: 209.55,
    height: 209.55,
    paperback: true,
    hardcover: false,
    popular: false,
  },
  {
    name: '209_279',
    labels: { mm: '210 × 279 mm', in: '8.25" × 11.00"' },
    width: 209.55,
    height: 279.4,
    paperback: false,
    hardcover: true,
    popular: false,
  },
  {
    name: '215_215',
    labels: { mm: '216 × 216 mm', in: '8.50" × 8.50"' },
    width: 215.9,
    height: 215.9,
    paperback: true,
    hardcover: false,
    popular: false,
  },
] as const
